import { useEffect, useState } from "react";

const BLOCKING_LAYERS = ".eamodal-overlay, .cookie-banner";
const REACT_MODAL_OPEN_CLASS = "ReactModal__Body--open";

const hasBlockingLayer = () =>
  document.body.classList.contains(REACT_MODAL_OPEN_CLASS) || Boolean(document.querySelector(BLOCKING_LAYERS));

/** Otwarty modal albo baner cookies zajmuje uwagę i dół ekranu, więc belka koszyka ustępuje. */
const useBlockingLayer = () => {
  const [isBlocked, setIsBlocked] = useState(hasBlockingLayer);

  useEffect(() => {
    const check = () => setIsBlocked(hasBlockingLayer());
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, attributes: true, attributeFilter: ["class"] });
    check();
    return () => observer.disconnect();
  }, []);

  return isBlocked;
};

export default useBlockingLayer;
